import React from 'react';
import Profile_pic from '../assets/profile.jpg';
import styled from 'styled-components';
import Curly from './Curly' 
import Connect from './Connect'
import Resume from './Resume'
import AOS from 'aos';
import 'aos/dist/aos.css';

const AboutSection = () => {
    AOS.init({
        duration: 1200,
    })
    return (
        <>
                <StyledAbout>
                    <div className = "description" id="about" >
                        <div className = "title">
                        <BigText >
                        <HI data-aos="fade-right">Hello!</HI>
                            <h2 data-aos="fade-right" data-aos-delay="100"> My name is <StyledA data-aos="fade-right" data-aos-delay="100">Aman Gupta</StyledA>
                            </h2>
                        </BigText>
                        <BigText data-aos="fade-right" data-aos-delay="300">
                            <h2 ><span>and I'm a</span></h2>
                        </BigText>
                        <BigText data-aos="fade-right" data-aos-delay="500">
                            <H2 ><span>React Developer.</span></H2>
                        </BigText>
                    </div>
                        <P data-aos="fade-up" >I'm very captivated by everything that has to do with front-end development & always working on some project or learning something new!</P>
                    <Resume />
                    
                </div>
                <DivConn  className = "image-section">
                    <Img data-aos="fade-left"
                        src = {Profile_pic} 
                        alt = "aman gupta"/>
                    <Connect className="connect"/>
                </DivConn>
                
            </StyledAbout>
            <Curly/>
            
        </>
    );
};

const StyledAbout = styled.div`
    height: 100vh;
    margin-top: 2rem;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 5rem 8rem;
    color: whitesmoke;
    margin-bottom: 2vh;
    
@media (max-width: 768px) {
    height: 45vh;
    display: block;
    text-align: center; 
    padding: 3rem;
    margin-top: 11rem;
    
    }
    
    
@media (max-width: 480px){
    padding: 1rem;
    text-align: center;
    margin-top: 9rem;
    
    } 
`
const HI = styled.h2 `
    font-weight: 900;
    font-size: 3.5rem;
    color: #3DC9A7; 
    font-family: 'Lato', sans-serif;
`
const P = styled.p`
    margin: 2.2rem 2rem 1rem 0rem;
    font-weight: 300;
    padding-right: 8rem;
    font-family: 'Montserrat', sans-serif;

@media (max-width: 768px){
    padding: 2rem;
    } 
@media (max-width: 480px){
    padding: 3rem 1rem 2rem;
    
    }
`
const H2 = styled.h2`
    font-weight: 900;
    color: #3DC9A7;
    font-family: 'Lato', sans-serif;
`
const StyledA = styled.a `
    color: #3DC9A7;
    font-weight: 900;
    font-family: 'Lato', sans-serif;
`
const Img = styled.img`
    width: 40vh;
    height: 40vh;
    margin-right: 5rem;
    margin-top: 7rem;
    position: relative;
    border-radius: 50%; 
    overflow: hidden;
    object-fit: cover;
    box-shadow: 1px 3px 32px -4px black;
    @media (max-width: 1024px){
        width: 20vh;
        height: 20vh;
    } 
@media (max-width: 768px){
    display: none;
    } 
@media (max-width: 480px){
    display: none; 
    }
`
const DivConn = styled.div`
@media (max-width: 768px){
    display: none;
    } 
@media (max-width: 480px){
    display: none; 
    }

`
const BigText = styled.div `
    /* overflow: hidden; */
    text-shadow: 0 15px 7px #081730; 
`
export default AboutSection;

